import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ImageCropperModalComponent } from '../image-cropper-modal/image-cropper-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ImageValidationService {

  imagesExtensions: any[] = ["image/jpg", "image/jpeg", "image/png"];
  imageUrl: any;      //almacena la url temporal para poder extraerla con el metodo getImageUrl()

  constructor(private modalController: ModalController) { }

  async cropImage(file: File, aspectRatio: number): Promise<Blob> {
    try {
      console.log("Este es el aspecto a recortar", aspectRatio)
      const url = URL.createObjectURL(file);
      const modal = await this.modalController.create({
        component: ImageCropperModalComponent,
        componentProps: {
          imageSrc: url,
          aspectRatio: aspectRatio
        }
      });
      await modal.present();
      const { data } = await modal.onWillDismiss();
      URL.revokeObjectURL(url);
      if (data?.croppedBlob) {
        return data.croppedBlob;
      } else {
        throw new Error('No se obtuvo un blob recortado');
      }
    } catch (error) {
      console.error('Error en el proceso de recorte del servicio de validacion de imagenes', error);
      throw error
    }
  }

  async openCropImage(file: File, aspectRatio: number): Promise<File> {
    const croppedBlob = await this.cropImage(file, aspectRatio);
    return new File([croppedBlob], file.name, { type: file.type });
  }

  validateExtension(file: File): boolean {
    console.log('el tipo es: ', file.type);
    if (!this.imagesExtensions.includes(file.type)) {
      console.warn('NO SE CUMPLE LA EXTENSION');
      return (false);
    } else {
      return (true);
    }
  }

  validateSizeFile(file: File): boolean {
    const maxSize = 5 * 1024 * 1024; // 5 MB
    console.log('el size es: ', file.size, 'se compara con max: ', maxSize);
    if (file.size > maxSize) {
      console.warn('NO SE CUMPLE EL TAMAÑO O EXTENSION');
      return (false);
    } else {
      return (true);
    }
  }

  async validateAspect(file: File): Promise<boolean> {
    try {
      const dimensions = await this.getImageDimensions(file);
      const imageAspectRatio = dimensions.width / dimensions.height;
      const aspectRatioThreshold = 0.5; // Permitir una diferencia de 50% en la relación de aspecto
      const targetAspectRatio = 4 / 3; // Relación de aspecto deseada para 4:3 = 1.3333
      const aspectRatioDifference = Math.abs(imageAspectRatio - targetAspectRatio);
      console.log('La diferencia para calcular la relación de aspecto (aspectRatio) es: ', aspectRatioDifference);

      if (aspectRatioDifference > aspectRatioThreshold) {
        console.warn('La relación de aspecto calculada para la imagen es mayor a la permitida');
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.error('Error al obtener las dimensiones de la imagen:', error);
      return false;
    }
  }

  async getImageDimensions(file: File): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        const width = img.naturalWidth || img.width;
        const height = img.naturalHeight || img.height;
        resolve({ width, height });
      };

      img.onerror = (error) => {
        console.warn('Error al cargar la imagen:', error);
        reject(new Error('Error al cargar la imagen'));
      };

      try {
        img.src = this.createObjectURL(file);
      } catch (error) {
        console.warn('Error al crear el objeto URL:', error);
        this.imageUrl = '';
        reject(new Error('Error al crear el objeto URL'));
      }
    });
  }

  createObjectURL(file: File | Blob | ArrayBuffer) {
    try {
      let blob: Blob;

      if (file instanceof File || file instanceof Blob) {
        blob = file;
      } else if (typeof file === 'string') {
        // Convertir una cadena a un Blob
        blob = new Blob([file], { type: 'text/plain' });
      } else if (file instanceof ArrayBuffer) {
        // Convertir un ArrayBuffer a un Blob
        blob = new Blob([file]);
      } else {
        // Si el objeto no es convertible, lanzar un error
        console.error('El objeto proporcionado no es un File ni un Blob, y no se puede convertir:', file);
        blob = file;
      }
      const url = URL.createObjectURL(blob);
      this.imageUrl = url;
      return url;
    } catch (error) {
      console.warn('Error creating Object URL:', error);
      throw error;
    }
  }

  revokeObjectURL() {
    if (this.imageUrl) {
      URL.revokeObjectURL(this.imageUrl);
      this.imageUrl = null;
    }
  }

  // Metodo para corregir la relación aspecto en el logo
  async correctAspectRatio(file: File, targetAspectRatio: number): Promise<{ blob: Blob, width: number, height: number }> {
    console.log("Aqui esta llamando al nuevo metodo")
    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);
      img.src = url;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        const { width, height } = img;
        const currentAspectRatio = width / height;

        // Redimensiona la imagen manteniendo su contenido pero ajustando las proporciones
        let newWidth, newHeight;
        if (currentAspectRatio > targetAspectRatio) {
          // Imagen más ancha que la proporción deseada
          newWidth = height * targetAspectRatio;
          newHeight = height;
        } else {
          // Imagen más alta que la proporción deseada
          newWidth = width;
          newHeight = width / targetAspectRatio;
        }

        canvas.width = newWidth;
        canvas.height = newHeight;

        // Dibuja la imagen ajustada al canvas
        ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

        // Convierte el contenido del canvas en un Blob
        canvas.toBlob((blob) => {
          if (blob) {
            resolve({ blob, width: canvas.width, height: canvas.height });
          } else {
            reject(new Error('Error al generar el blob de la imagen'));
          }
        }, file.type);
      };

      img.onerror = (error) => {
        reject(error);
      };
    });
  }

}
